import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.role) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
      setLoading(false);
    }
  };

  const input = "w-full bg-transparent border border-white/20 rounded-sm px-4 py-3.5 text-white placeholder-white/35 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-500/30 transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#050505] grain" data-testid="admin-login">
      <form onSubmit={submit} className="glass rounded-2xl p-10 max-w-sm w-full">
        <div className="w-12 h-12 rounded-full bg-purple-600 flex items-center justify-center mb-6">
          <Lock size={20} />
        </div>
        <h1 className="font-display uppercase text-3xl">Campaign Admin</h1>
        <p className="text-white/50 text-sm mt-2 mb-8">Neil Simon · Ward 9 Davenport</p>
        <div className="space-y-4">
          <input required type="email" data-testid="admin-email" className={input} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required type="password" data-testid="admin-password" className={input} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-btn" className="mt-8 w-full py-3.5 rounded-full bg-white text-black font-semibold hover:bg-purple-500 hover:text-white transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
